import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformancePIPCreatePage from "@/pages/admin/PerformancePIPCreatePage";

export const Route = createFileRoute("/_admin/admin/performance/pip/new")({
  head: () => pageHead("Admin · Performance · Pip · New", "AKIVA admin · performance · pip · new portal.", "/admin/performance/pip/new", true),
  component: PerformancePIPCreatePage,
});
